module.exports = "<style>#tplindicator_refer .ztree{overflow:hidden}</style> <div id=tplindicator_refer> <div class=u-row> <div class=u-col-4 style=height:464px;overflow:auto> <u-tree class=form-control params='vm: {data: treemodel, setting: treeOption},\n        umeta:{\"id\":\"certificationtree\",\"idField\":\"id\",\"pidField\":\"pid\",\"nameField\":\"title\"}'> </u-tree> </div> <div class=u-col-8> <u-grid params=\"config: gridconfig\"></u-grid> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/tplindicator/index.html
// module id = 406
// module chunks = 144